const fieldLabel = (field, destination) => {
  if (!field || !destination) {
    throw new Error('field and destination are required to generate a label');
  }
  return (field.label || destination.name) + (field.isRequired ? ' *' : '');
};
export default fieldLabel;
